import { Tween } from './Tween';

export class SequenceElement {
  public tweens: Tween[] = [];
  public callback: () => void | undefined;

  /**
   * Start tweens.
   */
  public start(): void {
    for (const tween of this.tweens) {
      tween.start();
    }
  }

  /**
   * Stop tweens.
   */
  public stop(): void {
    for (const tween of this.tweens) {
      tween.stop();
    }
  }

  /**
   * Pause tweens.
   */
  public pause(): void {
    for (const tween of this.tweens) {
      tween.pause();
    }
  }

  /**
   * Resume tweens.
   */
  public resume(): void {
    for (const tween of this.tweens) {
      tween.resume();
    }
  }

  /**
   * Return longest duration tween.
   */
  public longestDurationTween(): Tween {
    return this.tweens.reduce((a, b) => (a.duration >= b.duration ? a : b));
  }

  /**
   * Wait for sequence element completion.
   */
  public async waitForCompletion(): Promise<void[]> {
    const promises: Promise<void>[] = [];
    for (const tween of this.tweens) {
      promises.push(tween.waitForCompletion());
    }
    return Promise.all(promises);
  }
}
